import React from 'react';
import Group from '@mui/icons-material/Group';
import Avatar from 'components/shared/Avatar';
import { getStringValue } from 'util/Format';
import { JoinedCommunity } from 'store/types/Community';

import styles from './CommunityListItem.module.scss';

interface CommunityListItemProps {
  item: JoinedCommunity;
  active?: boolean;
  hasRequestedDate?: boolean;
}

const CommunityListItem: React.FunctionComponent<CommunityListItemProps> = ({
  item,
  active = false,
  hasRequestedDate = false,
}) => {
  const { logoUrl, name, member } = item;
  const { role, requestedDate, status } = member;

  return (
    <div className={styles.container}>
      <Avatar src={logoUrl} icon={<Group />} className={styles.avatar} />
      <div className={styles.description}>
        <h5 className={styles.name}>{name}</h5>
        {active ? (
          <span>{`Role: ${role}`}</span>
        ) : (
          <>
            {hasRequestedDate && <span>{`Date Requested: ${getStringValue(requestedDate, true)}`}</span>}
            <span>{`Status: ${status}`}</span>
          </>
        )}
      </div>
    </div>
  );
};
export default CommunityListItem;
